import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 5.5v5a1 1 0 0 0 1 1h5V14a.5.5 0 0 0 .854.354l6-6a.5.5 0 0 0 0-.708l-6-6A.5.5 0 0 0 8.001 2v2.5H3a1 1 0 0 0-1 1"
    }, null, -1)
  ])))
}
export default { render: render }